(function($) {

    function calculateNavHeight() {
        let topNavHeight = Math.ceil($(".mobile-nav .nav-content .top").outerHeight());
        let mobileNavMenuHeight = Math.ceil($(".mobile-nav").outerHeight());
        let bufferHeight = 80;
        let menuHeight = mobileNavMenuHeight - (topNavHeight + bufferHeight);
        $(".mobile-nav .nav-content .main").css("height", menuHeight + "px");
    }

    // $(window).on("resize", calculateNavHeight());

    $(".nav-toggle").on('click', function () {
       $nav = $("nav.mobile-nav");
       $nav.addClass('show');
       $("body").addClass('no-scroll');
       // calculateNavHeight();
    });

    $(".nav-close").on("click", function () {
        $nav = $("nav.mobile-nav");
        $nav.removeClass('show');
        $("body").removeClass('no-scroll');
    });



    $(".bottom-nav li").on("mouseover", function () {
       let $this = $(this);
       $(".bottom-nav .menu-item-has-children ul.active").removeClass('active');

       if($this.children('ul').length > 0) {
           $this.children("ul").addClass('active');
       }
    });

    $(".main-nav").on("mouseleave", function () {
        $(".bottom-nav .menu-item-has-children ul.active").removeClass('active');
    });


    $(".mobile-nav .main ul li.menu-item-has-children").each(function () {
        $(this).children("a").after('<div class="toggle"><i class="fa-light fa-chevron-down"></i></div>');
    });

    $(".mobile-nav .main ul li.menu-item-has-children .toggle").on("mousedown", function () {
        $(this).next(".sub-menu").slideToggle();
        $(this).toggleClass("active");
    });

})( jQuery );

